
// Initilise the Supplier Tender Editor page
var TECL_TenderSupplierEditor = {

  // Initialise the Tenders select page
  Initialise: function (supplierTenderEditor) {

    TECL_TenderSupplierGeneral.InitialiseAccordionControls();

    var jumpPoint = $("#JumpPoint").val();
    if (jumpPoint && jumpPoint == 1) {

      $("html,body").animate({ scrollTop: $("#questions").offset().top }, "slow");

      if (supplierTenderEditor) {
        TECL_Questions.ShowUnreadTab("userQuestionsTab", "userQuestions", "currentSupplierQuestionsTab", "currentSupplierQuestions");
      } else {
        TECL_Questions.ShowUnreadTab("userQuestionsTab", "userQuestions", "supplierQuestionsTab", "supplierQuestions");
      }
    } else {
      window.scrollTo(0, 0);
    }

    // Create the file upload control
    $("#schoolInvoicefiles").kendoUpload({
      async: {
        saveUrl: baseSiteUrl + "umbraco/Surface/Tender/SaveUploadFile?cacheId=" + $("#schoolInvoiceCacheId").val(),
        removeUrl: baseSiteUrl + "umbraco/Surface/Tender/RemoveUploadFile?cacheId=" + $("#schoolInvoiceCacheId").val(),
        autoUpload: true
      },
      complete: TECL_TenderAdditionalInformation.UpdateSummaryBox,
      onSuccess: TECL_TenderAdditionalInformation.UpdateSummaryBox
    });

    $("#edcoInvoicefiles").kendoUpload({
      async: {
        saveUrl: baseSiteUrl + "umbraco/Surface/Tender/SaveUploadFile?cacheId=" + $("#edcoInvoiceCacheId").val(),
        removeUrl: baseSiteUrl + "umbraco/Surface/Tender/RemoveUploadFile?cacheId=" + $("#edcoInvoiceCacheId").val(),
        autoUpload: true
      },
      complete: TECL_TenderAdditionalInformation.UpdateSummaryBox,
      onSuccess: TECL_TenderAdditionalInformation.UpdateSummaryBox
    });

    TECL_TenderSupplierEditor.RemoveAllTempQuestionFiles();
    TECL_TenderSupplierEditor.RemoveAllProposalUploadFiles();

  },

  // download a file
  DownloadFile: function (fileId, documentType, fileName, tenderId) {
    window.location = baseSiteUrl + "TenderSupplierSurface/DownloadFile?fileId=" + fileId + "&dt=" + documentType + "&fn=" + fileName + "&ti=" + tenderId;
  },

  // Remove a file and the linked element
  RemoveFile: function (fileId, elementId, documentType, fileName, tenderId) {
    
    if (elementId && fileName && tenderId && TECL_Master.AddLock("TenderSupplier_RemoveFile")) {
      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/TenderSupplierSurface/DeleteFile",
        dataType: "json",
        type: "POST",
        data: {
          fileName: fileName,
          documentType: documentType,
          tenderId: tenderId
        },
        error: function (exc) {
          TECL_Master.ClearLock("TenderSupplier_RemoveFile");
        },
        success: function (result) {
          TECL_Master.ClearLock("TenderSupplier_RemoveFile");
          $(elementId).addClass("hidden");
        }
      });
    }
  },

  // Clear out all the question and answer temp files
  RemoveAllTempQuestionFiles: function () {
    var tenderId = $("#TenderId").val();
    var parentTenderId = $("#ParentTenderId").val();

    if (TECL_Master.AddLock("TenderSupplier_RemoveAllTempQuestionFiles")) {

      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/TenderQuestionsSurface/RemoveTempQuestionsFiles",
        dataType: "json",
        type: "POST",
        data: {
          tenderId: tenderId,
          parentTenderId: parentTenderId
        },
        error: function (exc) {
          TECL_Master.ClearLock("TenderSupplier_RemoveAllTempQuestionFiles");
        },
        success: function (result) {
          TECL_Master.ClearLock("TenderSupplier_RemoveAllTempQuestionFiles");
        }
      });
    }
  },

  // Clear out all the question and answer temp files
  RemoveAllProposalUploadFiles: function () {
    var tenderId = $("#TenderId").val();
    var parentTenderId = $("#ParentTenderId").val();

    if (TECL_Master.AddLock("TenderSupplier_RemoveAllProposalUploadFiles")) {

      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/TenderSupplierSurface/ClearProposalsUploadFiles",
        dataType: "json",
        type: "POST",
        data: {
          tenderId: tenderId,
          parentTenderId: parentTenderId
        },
        error: function (exc) {
          TECL_Master.ClearLock("TenderSupplier_RemoveAllProposalUploadFiles");
        },
        success: function (result) {
          TECL_Master.ClearLock("TenderSupplier_RemoveAllProposalUploadFiles");
        }
      });
    }
  },

  // On successful upload of a proposal file
  onSuccess_proposalFiles: function (e) {
    if (TECL_Master.AddLock("onSuccess_proposalFiles")) {
      if (e.operation === "upload" && e.files != null && e.files.length > 0) {
        var file = e.files[0].rawFile;
        var fileName = file.name;
        if (file) {
          $.ajax({
            url: baseSiteUrl + "TenderSupplierSurface/SaveDownloadedFile",
            type: "POST",
            data: {
              fileName: fileName,
              documentType: 0, // Proposal enum number
              tenderId: $("#TenderId").val()
            },
            error: function (exc) {
              TECL_Master.ClearLock("onSuccess_proposalFiles");
            },
            success: function (html) {
              TECL_Master.ClearLock("onSuccess_proposalFiles");
              if (html != null) {
                var listContainer = $("#FileUploader_proposalFileUploader").find("[name=UploadFilesList]");
                $(html).appendTo(listContainer);

                var $proposalUploader = $("#FileUploader_proposalFileUploader");

                if ($proposalUploader) {
                  var $errorSpan = $proposalUploader.find("[name=ValidationText]");

                  if ($errorSpan && $errorSpan.hasClass("hidden")) {
                    $errorSpan.addClass("hidden");
                  }
                }
              }
            }
          });
        }
      }
    }
  },

  // On successful upload of a case studies file
  onSuccess_casestudiesFiles: function (e) {
    if (TECL_Master.AddLock("onSuccess_casestudiesFiles")) {
      if (e.operation == "upload" && e.files != null && e.files.length > 0) {
        var file = e.files[0].rawFile;

        if (file) {
          $.ajax({
            url: baseSiteUrl + "TenderSupplierSurface/SaveDownloadedFile",
            type: "POST",
            data: {
              fileName: file.name,
              documentType: 1, // Case Studies enum number
              tenderId: $("#TenderId").val()
            },
            error: function (exc) {
              TECL_Master.ClearLock("onSuccess_casestudiesFiles");
            },
            success: function (html) {
              TECL_Master.ClearLock("onSuccess_casestudiesFiles");
              if (html != null) {
                var listContainer = $("#FileUploader_caseStudiesFileUploader").find("[name=UploadFilesList]");
                $(html).appendTo(listContainer);
              }
            }
          });
        }
      }
    }
  },

  // On successful upload of a term and conditions file
  onSuccess_tandcsFiles: function (e) {
    if (TECL_Master.AddLock("onSuccess_tandcsFiles")) {
      if (e.operation == "upload" && e.files != null && e.files.length > 0) {
        var file = e.files[0].rawFile;

        if (file) {
          $.ajax({
            url: baseSiteUrl + "TenderSupplierSurface/SaveDownloadedFile",
            type: "POST",
            data: {
              fileName: file.name,
              documentType: 2, // T&C's enum number
              tenderId: $("#TenderId").val()
            },
            error: function (exc) {
              TECL_Master.ClearLock("onSuccess_tandcsFiles");
            },
            success: function (html) {
              TECL_Master.ClearLock("onSuccess_tandcsFiles");
              if (html != null) {
                var listContainer = $("#FileUploader_tandcsFileUploader").find("[name=UploadFilesList]");
                $(html).appendTo(listContainer);
              }
            }
          });
        }
      }
    }
  },

  // Save the suppliers proposal as a draft version
  SaveProposalAsDraft: function () {
    TECL_TenderSupplierEditor.SaveProposal(false);
  },

  // Submit the proposal
  SubmitProposal: function () {
    var isValid = TECL_TenderSupplierEditor.ValidateProposal();

    if (isValid) {
      $("#submitProposalDlg").modal("show");
    } else {
      $("#validationErrorDlg").modal("show");
    }
  },

  // Validate proposal data
  ValidateProposal: function () {

    var isValid = true;
    var $mainDiv = $("#SupplierTenderEditor");

    // Clear all errors
    var $errorSpans = $("[name=ValidationText]");
    if ($errorSpans && $errorSpans.length > 0) {
      $errorSpans.each(function () {
        $(this).addClass("hidden");
      });
    }

    if ($mainDiv) {
      var isMinMaxValid = true;

      // Check all required currency entries
      $mainDiv.find("[name=requiredQuestionCurrency]").each(function () {
        var value = $(this).find(".answer_text").val();

        if (!value || value <= 0) {
          isMinMaxValid = false;

          // show error
          var $errorSpan = $(this).find("[name=ValidationText]");
          if ($errorSpan && $errorSpan.length > 0) {
            $errorSpan.removeClass("hidden");
          }
        }
      });

      if (isMinMaxValid) {
        var isMinMoreThanMax = TECL_TenderSupplierEditor.IsMinMoreThanMax();
        isMinMaxValid = !isMinMoreThanMax;

        if (isMinMoreThanMax) {
          //show error
          var $minMaxRowError = $(".requiredMinMaxQuestionRow").find(".minMaxValidation");

          if ($minMaxRowError && $minMaxRowError.length > 0) {
            $minMaxRowError.removeClass("hidden");
          }
        }
      }

      var isRequiredQuestionsValid = true;

      // Check all required string entries
      $mainDiv.find("[name=requiredQuestionString]").each(function () {
        var value = $(this).find(".answer_text").val();

        if (!value || value == "") {
          isRequiredQuestionsValid = false;

          // show error
          var $errorSpan = $(this).find("[name=ValidationText]");
          if ($errorSpan && $errorSpan.length > 0) {
            $errorSpan.removeClass("hidden");
          }
        }
      });

      // Check if any proposal documents have been uploaded
      var $proposalUploader = $("#FileUploader_proposalFileUploader");
      var anyProposalDocs = false;

      if ($proposalUploader) {
        $proposalUploader.find("[name=filesListItem]").each(function () {

          if (!$(this).hasClass("hidden")) {
            anyProposalDocs = true;
          }
        });

        if (!anyProposalDocs) {
          var $errorSpan = $proposalUploader.find("[name=ValidationText]");
          if ($errorSpan && $errorSpan.length > 0) {
            $errorSpan.removeClass("hidden");
          }
        }
      }

      // Set isInvalid and scroll into view
      if (!isMinMaxValid || !isRequiredQuestionsValid) {
        isValid = false;

        $([document.documentElement, document.body]).animate({
          scrollTop: $("#tenderRequiredInformation").offset().top
        }, 2000);
      } else if (!anyProposalDocs) {
        isValid = false;

        $([document.documentElement, document.body]).animate({
          scrollTop: $("#tenderUploadProposalFilesId").offset().top
        }, 2000);
      }

    } else {
      // Page failure
      isValid = false;
    }
    return isValid;
  },

  // Show the not interested check dialog
  ShowNotInterestedCheckDlg: function () {
    $("#notInterestedCheckDlg").modal("show");
  },

  // Change the supplier status to not interested
  ChangeToNotInterested: function (redirectUrl) {
    if (redirectUrl) {
      if (TECL_Master.AddLock("ChangeToNotInterested")) {
        $.ajax({
          url: baseSiteUrl + "TenderUserSurface/ChangeTenderSupplierStatus",
          dataType: "json",
          type: "POST",
          data: {
            supplierTenderId: $("#TenderId").val(),
            newStatus: "optout"
          },
          error: function () {
            TECL_Master.ClearLock("ChangeToNotInterested");
            TECL_Master.ShowErrorDialog();
          },
          success: function () {
            TECL_Master.ClearLock("ChangeToNotInterested");
            window.location.replace(redirectUrl);
          }
        });
      }
    }
  },

  // Save the suppliers proposal information
  SaveProposal: function (submitProposal) {
    $("#submitProposalDlg").modal("hide");

    if (TECL_Master.AddLock("TECL_TenderSupplierEditor_SaveTender")) {
      var isValid;

      if (submitProposal) {
        isValid = TECL_TenderSupplierEditor.ValidateRequiredQuestionData();
      } else {
        // Don't validate for draft
        isValid = true;
      }

      var tenderId = $("#TenderId").val();

      if (isValid && tenderId) {
        var saveQuestionsData = TECL_TenderSupplierEditor.GetRequiredQuestionDatas();
        var saveFileDatas = TECL_TenderSupplierEditor.GetProposalFilesDatas();
        $.ajax({
          url: baseSiteUrl + "TenderSupplierSurface/SaveProposal",
          type: "POST",
          dataType: "json",
          data: {
            tenderId: tenderId,
            questionsData: saveQuestionsData,
            submitProposal: submitProposal,
            filesData: saveFileDatas
          },
          error: function (exc) {
            TECL_Master.ClearLock("TECL_TenderSupplierEditor_SaveTender");
            if (submitProposal) {
              TECL_Master.ShowErrorDialog("Failed to submit the proposal");
            } else {
              TECL_Master.ShowErrorDialog("Failed to save the proposal");
            }
          },
          success: function (saved) {
            TECL_Master.ClearLock("TECL_TenderSupplierEditor_SaveTender");

            if (saved && saved === true) {
              if (submitProposal) {
                TECL_Master.DisplayNoticeDlg("Your proposal has been successfully submitted", "TECL_Master.ReloadPage");
              } else {
                TECL_Master.DisplayNoticeDlg("Your draft proposal has been successfully saved", "TECL_Master.ReloadPage");
              }
            } else {
              if (submitProposal) {
                TECL_Master.ShowErrorDialog("Failed to submit the proposal");
              } else {
                TECL_Master.ShowErrorDialog("Failed to save the proposal");
              }
            }
          }
        });
      } else {
        TECL_Master.ClearLock("TECL_TenderSupplierEditor_SaveTender");
      }
    }
  },

  // Validate the required questions data
  ValidateRequiredQuestionData: function () {
    var isValid = true;
    $("#tenderRequiredInformation").find(".tenderSupplierRequiredQuestionRow").each(function () {
      var value = $(this).find(".answer_text").val();

      if (value) {
        // Make sure the validation text is hidden
        $(this).find("[name=ValidationText]").addClass("hidden");
      } else {
        // Report a fail and show the validation text
        isValid = false;
        $(this).find("[name=ValidationText]").removeClass("hidden");
      }
    });
    return isValid;
  },

  // Check if the min and max values overlap
  IsMinMoreThanMax: function () {
    var $mainDiv = $("#SupplierTenderEditor");
    var isMinMoreMax = false;

    if ($mainDiv) {
      var $minParentDiv = $mainDiv.find("[data-fieldname=TenderMinimumPrice]");
      var $maxParentDiv = $mainDiv.find("[data-fieldname=TenderMaximumPrice]");

      if ($minParentDiv && $maxParentDiv) {
        var $minInput = $minParentDiv.find(".answer_text");
        var $maxInput = $maxParentDiv.find(".answer_text");

        if ($minInput && $maxInput) {
          var minPrice = parseInt($minInput.val());
          var maxPrice = parseInt($maxInput.val());

          if (minPrice > 0 && maxPrice > 0 && minPrice > maxPrice) {
            isMinMoreMax = true;
          }
        }
      }
    }
    return isMinMoreMax;
  },

  // Gets the required questions data
  GetRequiredQuestionDatas: function () {
    var saveQuestionsData = [];
    $("#tenderRequiredInformation").find(".tenderSupplierRequiredQuestionRow").each(function () {
      var fieldName = $(this).attr("data-fieldName");
      var value = $(this).find(".answer_text").val();

      questionsData = {
        FieldName: fieldName,
        AnswerValue: value
      }

      saveQuestionsData.push(questionsData);
    });
    return saveQuestionsData;
  },

  // Get uploaded proposal files 
  GetProposalFilesDatas: function () {
    var saveFileDatas = [];

    TECL_TenderSupplierEditor.GetProposalFileDatas(saveFileDatas, $("#FileUploader_proposalFileUploader"), 0);
    TECL_TenderSupplierEditor.GetProposalFileDatas(saveFileDatas, $("#FileUploader_caseStudiesFileUploader"), 1);
    TECL_TenderSupplierEditor.GetProposalFileDatas(saveFileDatas, $("#FileUploader_tandcsFileUploader"), 2);

    return saveFileDatas;
  },

  // Get uploaded proposal files for a document type
  GetProposalFileDatas: function (saveFileDatas, fileManagerElement, documentType) {

    if (fileManagerElement) {
      var listContainer = $(fileManagerElement).find("[name=UploadFilesList]");

      if (listContainer) {
        $(listContainer).find("[name=filesListItem]").each(function () {
          // Add file data to the array
          var id = $(this).attr("data-documentId");
          var fieldName = $(this).attr("data-fileName");
          var deleted = $(this).hasClass("hidden");

          fileData = {
            Id: id,
            Filename: fieldName,
            DocumentType: documentType,
            Deleted: deleted
          }

          saveFileDatas.push(fileData);
        });
      }
    }
    return saveFileDatas;
  },

  // Display the rejections dialog
  DisplayRejectionDlg: function () {
    var tenderId = $("#TenderId").val();
    var umbracoNodeId = $("#UmbracoNodeId").val();

    if (TECL_Master.AddLock("DisplayRejectionDlg")) {
      TECL_TenderGeneral.DisplayPleaseWaitDlg();

      $.ajax({
        url: baseSiteUrl + "TenderSupplierSurface/GetRejectionDialog",
        type: "POST",
        data: {
          tenderSupplierId: tenderId,
          umbracoNodeId: umbracoNodeId
        },
        error: function (exc) {
          TECL_Master.ClearLock("DisplayRejectionDlg");
          TECL_TenderGeneral.HidePleaseWaitDlg();
        },
        success: function (viewHtml) {
          TECL_Master.ClearLock("DisplayRejectionDlg");
          TECL_TenderGeneral.HidePleaseWaitDlg();

          if (viewHtml) {
            $("#rejectionReasonDlgDiv").html(viewHtml);
            $("#rejectionReasonDlg").modal("show");
          }
        }
      });
    }
  },

  // Display the send details dialog
  DisplaySendDetailsDlg: function () {
    $("#proposalDetailsDlg").modal("show");
  },

  // Display the send school invoice dialog
  DisplaySendSchoolInvoiceDlg: function () {
    var hidden = $(".sendDetailsBtn").hasClass("hidden");
    if (hidden) {
      $("#schoolInvoiceDlg").modal("show");
    } else {
      TECL_Master.DisplayNoticeDlg($("#proposalDetailsNotCompleted").val());
    }
  },

  // Display the request Edco invoice dialog
  DisplayRequestEdcoInvoiceDlg: function () {
    var hidden = $(".invoiceSchoolBtn").hasClass("hidden");
    if (hidden) {
      $("#edcoInvoiceDlg").modal("show");
    } else {
      TECL_Master.DisplayNoticeDlg($("#schoolInvoiceNotCompleted").val());
    }
  },

  // Submit the delivery details dialog data 
  SubmitSendDetailsDlg: function () {
    $("#proposalDetailsPriceVal").addClass("hidden");
    $("#proposalDetailsScheduleVal").addClass("hidden");
    var price = $("#proposalDetailsPrice").val();
    var scheduleText = $("#proposalDetailsScheduleText").val();
    var isValid = true;

    if (!price || price == "" || price <= 0.0) {
      $("#proposalDetailsPriceVal").removeClass("hidden");
      isValid = false;
    }

    if (!scheduleText || scheduleText == "" || scheduleText.length <= 0) {
      $("#proposalDetailsScheduleVal").removeClass("hidden");
      isValid = false;
    }

    if (isValid && TECL_Master.AddLock("SubmitSendDetailsDlg")) {
      $.ajax({
        url: baseSiteUrl + "TenderSupplierSurface/SendDeliveryDetails",
        type: "POST",
        data: {
          parentTenderId: $("#ParentTenderId").val(),
          supplierTenderId: $("#TenderId").val(),
          cacheId: $("#schoolInvoiceCacheId").val(),
          price: price,
          scheduleText: scheduleText
        },
        error: function (exc) {
          TECL_Master.ClearLock("SubmitSendDetailsDlg");
          TECL_Master.ShowErrorDialog();
        },
        success: function (result) {
          TECL_Master.ClearLock("SubmitSendDetailsDlg");
          if (result && result.Saved) {
            $(".sendDetailsBtn").addClass("hidden");
            $(".sendDetailsComplete").removeClass("hidden");
            $("#proposalDetailsDlg").modal("hide");
          } else {
            TECL_Master.ShowErrorDialog();
          }
        }
      });
    }
  },

  // Submit the school invoice dialog data 
  SubmitSchoolInvoiceDlg: function () {
    $("#schoolInvoiceFilesVal").addClass("hidden");
    var notes = $("#schoolInvoiceAdditionalNotesText").val();

    if (TECL_Master.AddLock("SubmitSchoolInvoiceDlg")) {
      $.ajax({
        url: baseSiteUrl + "TenderSupplierSurface/SendSchoolInvoice",
        type: "POST",
        data: {
          parentTenderId: $("#ParentTenderId").val(),
          supplierTenderId: $("#TenderId").val(),
          cacheId: $("#schoolInvoiceCacheId").val(),
          notes: notes
        },
        error: function (exc) {
          TECL_Master.ClearLock("SubmitSchoolInvoiceDlg");
          TECL_Master.ShowErrorDialog();
        },
        success: function (result) {
          TECL_Master.ClearLock("SubmitSchoolInvoiceDlg");
          if (result) {
            if (!result.HasFiles) {
              $("#schoolInvoiceFilesVal").removeClass("hidden");
            } else if (result.Saved) {
              $(".invoiceSchoolBtn").addClass("hidden");
              $(".invoiceSchoolComplete").removeClass("hidden");
              $("#schoolInvoiceDlg").modal("hide");
            }
          } else {
            TECL_Master.ShowErrorDialog();
          }
        }
      });
    }
  },

  // Submit the Edco invoice dialog data 
  SubmitRequestEdcoInvoiceDlg: function () {
    $("#edcoInvoiceFilesVal").addClass("hidden");
    var notes = $("#edcoInvoiceAdditionalNotesText").val();

    if (TECL_Master.AddLock("SubmitRequestEdcoInvoiceDlg")) {
      $.ajax({
        url: baseSiteUrl + "TenderSupplierSurface/RequestEdcoInvoice",
        type: "POST",
        data: {
          parentTenderId: $("#ParentTenderId").val(),
          supplierTenderId: $("#TenderId").val(),
          cacheId: $("#edcoInvoiceCacheId").val(),
          notes: notes
        },
        error: function (exc) {
          TECL_Master.ClearLock("SubmitRequestEdcoInvoiceDlg");
          TECL_Master.ShowErrorDialog();
        },
        success: function (result) {
          TECL_Master.ClearLock("SubmitRequestEdcoInvoiceDlg");
          if (result) {
            if (!result.HasFiles) {
              $("#edcoInvoiceFilesVal").removeClass("hidden");
            } else if (result.Saved) {
              $(".requestInvoiceBtn").addClass("hidden");
              $(".requestInvoiceComplete").removeClass("hidden");
              $("#edcoInvoiceDlg").modal("hide");
            }
          } else {
            TECL_Master.ShowErrorDialog();
          }
        }
      });
    }
  }
  
};